import { render, staticRenderFns } from "./BodyCircumferenceCreation.vue?vue&type=template&id=6d910529&scoped=true"
import script from "./BodyCircumferenceCreation.vue?vue&type=script&lang=js"
export * from "./BodyCircumferenceCreation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d910529",
  null
  
)

export default component.exports